const crypto = require('crypto');
const format = require('biguint-format');

const random_generator = (bytes) => {
    const id = crypto.randomBytes(bytes ? bytes : 10);
    return format(id, 'hex');
}

export default random_generator